<template>
  <div class="result_list"
       :item="item"
       @click="showDetail"
       :key="item.spec_id">
    <header class="result_list_name">{{item.name}}</header>
    <div class="result_list_detail">
      <span>{{item.width_px}} × {{item.height_px}} px</span>
      <span>{{item.width_mm}} × {{item.height_mm}} mm</span>
      <span v-if="isSize">{{size}}</span>
    </div>
    <img src="../assets/icon_arrow.png"
         class='arrow' />
  </div>
</template>

<script>
import { caculateSize } from '../utils/utils';

export default {
  props: ['item'],
  methods: {
    showDetail: function () {
      let { spec_id, name } = this.item;
      const specInfo = {
        specId: spec_id,
        specName: name
      }
      this.$emit('showDetailInfo', specInfo);
    }
  },
  computed: {
    isSize: function () {
      return this.item.file_size_min || this.item.file_size_max;
    },
    size: function () {
      if (this.isSize) {
        return caculateSize(this.item.file_size_min, this.item.file_size_max);
      }
    }
  }
}
</script>

<style scoped>
.result_list {
  position: relative;
  background-color: #fff;
  border-top: solid 1px #eee;
  border-bottom: solid 1px #eee;
  padding: 0 1em;
  height: 1rem;
  margin: 0.1rem;
}
.result_list_name {
  margin: 0.23rem 0 0.5em 0;
  color: #333333;
  font-size: 0.16rem;
}
.result_list_detail {
  display: inline-flex;
  margin: 0 0 0.23rem 0;
}
.result_list_detail span {
  margin-right: 1em;
  color: #999999;
  font-size: 0.12rem;
}
.arrow {
  width: 0.07rem;
  height: 0.12rem;
  position: absolute;
  top: 0.44rem;
  right: 0.44rem;
}
</style>
